import React, { useContext, useState } from 'react'
import noteContext from '../context/Notes/NoteContext'

const Addnote = () => {

    const [authtoken, setauthtoken] = useState(localStorage.getItem("token"))
    const context = useContext(noteContext)
    const { addnote } = context;

    const [note, setnote] = useState({ title: "", description: "", tag: "" })

    const handleclick = async (e) => {
        e.preventDefault();
        await addnote(note.title, note.description, note.tag);

        let data = {
            title: note.title,
            description: note.description,
            tag: note.tag
        }

        const response = await fetch("https://floatnotes.onrender.com/api/notes/addnote", {
            method: "POST",
            mode: "cors",
            headers: {
                "Content-Type": "application/json",
                "auth-token":authtoken
            },
            body: JSON.stringify(data),
        });

    }

    const onchange = (e) => {
        setnote({ ...note, [e.target.name]: e.target.value })
    }

    return (
        <>
            <h1>Add a note</h1>
            <form className="my-4" onSubmit={handleclick}>
                <div className="mb-3">
                    <label htmlFor="title" className="form-label">Title</label>
                    <input type="text" required minLength={5} onChange={onchange} className="form-control" id="title" name='title' aria-describedby="emailHelp" />
                </div>
                <div className="mb-3">
                    <label htmlFor="description" className="form-label">Description</label>
                    <input type="text" required minLength={8} value={note.description} onChange={onchange} className="form-control" id="description" name="description" rows={5} />
                </div>
                <button className="btn btn-dark">Add note</button>
            </form>
        </>
    )
}

export default Addnote



